import analytics from 'scripts/lib/analytics';

export default class ObserverCoach {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId, isMuted }) {
    let phoneCallItem = this.context.stores.conversationHistory.find(conversationItemId);
    let currentAgent = this.context.stores.currentAgent.get();

    let agentParticipantIds = phoneCallItem.content.getAgentParticipantIdsOnCall();
    if (agentParticipantIds.length === 0) {
      // No agent currently on the call
      return;
    }

    if (!phoneCallItem.content.isParticipantObserver(currentAgent.id)) {
      return;
    }

    this.context.gateways.phoneControlsHttp.observerCoach(customerId, conversationItemId, {
      participantId: currentAgent.id,
      coachedParticipantId: agentParticipantIds[0],
      unmuted: !isMuted,
    });

    analytics.track('Hero Coaching - Observer Coaching', { customerId, conversationItemId });
  }
}
